import initRaceMap from './map';
import {Runner} from './models/runner';
import ApiProvider from './providers/api';
import PassedWaypoints from './providers/passed-waypoints';
import initRunnersStore, {RunnersStore} from './store/runners';
import RunnersProvider, {RunnersDetailResponse} from './providers/runners';
import RenderProvider from './providers/render';
import RunProvider from './providers/run';
import RunnerCountdown from './providers/runner-countdown';
import RunnerStatistics from './providers/runner-statistics';

export default class Tracking {
    private year: number;

    private runProvider: RunProvider;

    private runnersProvider: RunnersProvider;

    private renderProvider: RenderProvider;

    private runnerCountdown: RunnerCountdown;

    private runnerStatistics: RunnerStatistics;

    private passedWaypoints: PassedWaypoints;

    private favoriteRunners: RunnersStore;

    private apiProvider: ApiProvider;

    constructor() {
        this.runProvider = RunProvider.getInstance();
        this.runnersProvider = RunnersProvider.getInstance();
        this.renderProvider = RenderProvider.getInstance();
        this.runnerCountdown = RunnerCountdown.getInstance();
        this.runnerStatistics = RunnerStatistics.getInstance();
        this.passedWaypoints = PassedWaypoints.getInstance();
        this.favoriteRunners = initRunnersStore();

        this.year = this.runProvider.getPreviousYear();
    }

    async fetchRunnersDetail(year: number, startNumbers: Array<string>) {
        this.apiProvider = new ApiProvider();
        return this.apiProvider.getData<RunnersDetailResponse>(year, `runners/${startNumbers.join(',')}`);
    }

    async init() {
        await initRaceMap();

        let requestedRunner: Runner;
        const {favoriteRunner: defaultFavoriteRunner} = this.favoriteRunners.getState();

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('startNumber') && urlParams.has('raceYear')) {
            const startNumber = urlParams.get('startNumber');
            const year = urlParams.get('raceYear');

            if (!Number.isNaN(parseInt(year, 10))) {
                const result = await this.fetchRunnersDetail(
                    Number(year),
                    [startNumber],
                );

                if (result.data?.length && result.data[0].run) {
                    requestedRunner = new Runner(result.data[0]);
                }
            }

            if (requestedRunner) {
                this.updateRunner(requestedRunner);
                this.favoriteRunners.setFavoriteRunner(requestedRunner);
            } else {
                this.favoriteRunners.removeFavoriteRunner();
            }
        } else if (defaultFavoriteRunner) {
            this.updateRunner(defaultFavoriteRunner);
        }

        this.favoriteRunners.subscribe(({favoriteRunner}) => {
            if (!favoriteRunner) {
                this.runnersProvider.unsubscribe();
                this.runnerCountdown.unsubscribe();
                this.runnerStatistics.unsubscribe();
                this.passedWaypoints.unsubscribe();
                return;
            }

            this.updateRunner(favoriteRunner);
        });
    }

    updateRunner(runner: Runner) {
        this.renderProvider.renderFavoriteRunner(runner);

        this.runnersProvider.subscribe([runner]);

        if (runner.hasFinished()) {
            this.renderProvider.showFinishScreen();
        } else {
            this.renderProvider.hideFinishScreen();
        }

        if (!runner.hasDetailedData()) return;

        this.runnerStatistics.subscribe(runner);
        this.runnerCountdown.subscribe(runner);
        this.passedWaypoints.subscribe(runner);
    }
}
